import { store } from '../../../redux/store'
import FileService from "../FileService";
import { dataChanged } from './fileListSlice'
import ArrayUtils from "../../../utils/ArrayUtils";
import RequestQueue from "../../../utils/net/RequestQueue";

let isInitialized = false
let queue;

if (!isInitialized) {
    isInitialized = true
    queue = new RequestQueue()
    queue.subscribe({
        success: function (r) {
            const state = store.getState()

            if (state.fileList.requestParams.offset > 0) {
                r.data.items = ArrayUtils.merge(state.fileList.data.items, r.data.items, (i) => i.id)
            }

            store.dispatch(dataChanged(r.data))
        },
        error: function (r) {
            // TODO: rozwazyc powiadomienie uzytkownika o bledzie.
            console.error(r)
        },
        complete: function (r) {
            console.debug('Stream of file list request has been completed.')
        } 
    })
}

const FileListDataManager = {
    load: function() {
        const state = store.getState()
        queue.addRequest(FileService.findFiles(state.fileList.requestParams))
    }
}

export default FileListDataManager